// lib
import { batch } from "react-redux";
import { any, pick } from "ramda";
// src
import back from "services/plannings";
import { setThrottledTimout } from "utils/timeout";
import { asArray, join } from "utils/presets";
import { computeDisplay, fetchEnableds } from "actions/events/thunks";
import * as sync from "./index";

// API

export const patchPrefs = () => async (dispatch, getState) => {
  setThrottledTimout(
    async () => {
      const { byId, enabledIds, favoriteIds, version } = getState().presets;
      // only sent favorites related info
      const partialById = pick(favoriteIds, byId);
      const partialEnableds = enabledIds.filter((id) => favoriteIds.includes(id));
      await back.request(
        {
          resource: "/my/prefs",
          method: "PATCH",
          body: JSON.stringify({
            byId: partialById,
            enabledIds: partialEnableds,
            favoriteIds,
            version,
          }),
        },
        dispatch,
        getState,
        () => dispatch(sync.patchPrefsRequest()),
        (json) => dispatch(sync.patchPrefsSuccess(json)),
        () => dispatch(sync.patchPrefsFailure()),
      );
    },
    1000,
    "thunks/patch/prefs",
  );
};

// working with ids

const patchPrefsIfFavorite = (ids) => async (dispatch, getState) => {
  const { favoriteIds } = getState().presets;
  const isNecessary = any((id) => favoriteIds.includes(id), asArray(ids));
  if (isNecessary) dispatch(patchPrefs());
};

export const updateAndPatchFavorites = (prefs) => async (dispatch) => {
  batch(() => {
    dispatch(sync.updateFavorites(prefs));
    dispatch(patchPrefs());
  });
};

// enable, fetch (thus recompute), patch
export const enablePreset = (id) => async (dispatch) => {
  batch(() => {
    dispatch(sync.addToEnableds(id));
    dispatch(fetchEnableds());
    dispatch(patchPrefsIfFavorite(id));
  });
};

// disabled, recompute, patch
export const disablePreset = (id) => async (dispatch) => {
  batch(() => {
    dispatch(sync.removeFromEnableds(id));
    dispatch(computeDisplay());
    dispatch(patchPrefsIfFavorite(id));
  });
};

export const enableCategory = (id) => async (dispatch, getState) => {
  const { byId, favoriteIds } = getState().presets;
  const favorites = join(byId, favoriteIds);
  const children = favorites.filter((f) => f.underId === id);
  batch(() => {
    dispatch(sync.addToEnableds(id));
    for (const { id: childId } of children) {
      dispatch(sync.addToEnableds(childId));
    }
    dispatch(fetchEnableds());
    dispatch(patchPrefs());
  });
};

export const disableCategory = (id) => async (dispatch, getState) => {
  const { byId, favoriteIds } = getState().presets;
  const favorites = join(byId, favoriteIds);
  const children = favorites.filter((f) => f.underId === id);
  batch(() => {
    dispatch(sync.removeFromEnableds(id));
    for (const { id: childId } of children) {
      dispatch(sync.removeFromEnableds(childId));
    }
    dispatch(computeDisplay());
    dispatch(patchPrefs());
  });
};

export const manageRemoveFromLocalsWithId = (ids) => async (dispatch) => {
  batch(() => {
    dispatch(sync.removeFromLocals(ids));
    dispatch(sync.removeFromEnableds(ids));
    dispatch(computeDisplay());
  });
};

export const manageRemoveFromFavoritesWithId = (id) => async (dispatch) => {
  batch(() => {
    dispatch(sync.removeFromFavorites(id));
    dispatch(sync.removeFromEnableds(id));
    dispatch(computeDisplay());
    dispatch(patchPrefs());
  });
};

// working with presets

export const manageAddToFavorites = (presets) => async (dispatch) => {
  batch(() => {
    dispatch(sync.addToFavoritesAndEnable(presets));
    dispatch(fetchEnableds());
    dispatch(patchPrefs());
  });
};

export const manageAddToLocals = (presets) => async (dispatch) => {
  batch(() => {
    dispatch(sync.addToLocalsAndEnable(presets));
    dispatch(fetchEnableds());
  });
};

// fetch

export const fetchPopulars = () => async (dispatch, getState) => {
  await back.request(
    "/presets/popular",
    dispatch,
    getState,
    () => dispatch(sync.popularsRequest()),
    (json) => dispatch(sync.popularsSuccess(json)),
    () => dispatch(sync.popularsFailure()),
  );
};
